var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M9.06 8l4.47 4.47c.707.707-.353 1.767-1.06 1.06L8 9.06l-4.47 4.47c-.707.707-1.767-.353-1.06-1.06L6.94 8 2.47 3.53c-.707-.707.353-1.767 1.06-1.06L8 6.94l4.47-4.47c.707-.707 1.767.353 1.06 1.06L9.06 8z", fill: "#FFF", fillRule: "evenodd" })
  );
});